<template>
  <div>
    <button
      class="btn btn-purple ml-2 text-uppercase"
      @click="onExport"
      :disabled="!hasSelected && !canExport"
    >Export to csv
    </button>
  </div>
</template>

<script>
import eventBus from "../../../event-bus";
import Download from "../../../mixins/download";

export default {
  data() {
    return {
      current: null,
    };
  },

  computed: {
    /**
     * @return {Boolean}
     */
    hasSelected() {
      return Boolean(this.current);
    },

    /**
     * @return {String}
     */
    getExportUrl() {
      return _.get(this.current, 'exportUrl');
    },

    /**
     * @return {boolean}
     */
    canExport() {
      return Boolean(_.get(this.current, 'canExport', false));
    },
  },

  methods: {
    /**
     * @param {Object|null} item
     */
    onSendListSelected(item) {
      this.current = item;
    },

    /**
     * @return {undefined}
     */
    onExport() {
      this.download(_.assign({}, {url: this.getExportUrl}));
    },
  },

  created() {
    eventBus.$on('send-list-select', this.onSendListSelected);
  },

  beforeDestroy() {
    eventBus.$off('send-list-select', this.onSendListSelected);
  },

  mixins: [
    Download,
  ],
}
</script>

<style scoped>

</style>
